import { VOUCHERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'

const update_voucher_request = () => {
  return {
    type: vouchersTypes.update.request
  }
}

const update_voucher_success = (response) => {
  return {
    type: vouchersTypes.update.success,
    payload: response.data.voucher
  }
}

const update_voucher_failure = (messages) => {
  return {
    type: vouchersTypes.update.failure,
    payload: messages
  }
}

const update_voucher = (voucher_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_voucher_request())

    // Request
    axios.patch(
      formatRoute(VOUCHERS_ROUTES.update, {id: voucher_id}),
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "Voucher data has been updated")
      dispatch( update_voucher_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating voucher."]
      }
      window.showSnackbar('error', errors)
      dispatch( update_voucher_failure(errors))
    })
  }

}

export {
  update_voucher
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/update.js